// src/hooks/useUnitImageGallery.js
import { useState } from "react";
import { useDisclosure } from "@chakra-ui/react";

/**
 * Wraps modal state + title + images for the ImageGalleryModal.
 * Pass a `getImagesForUnit(unit)` function that returns:
 *   - string[] of signed URLs, or
 *   - { src:string, alt?:string }[]
 */
export const useUnitImageGallery = ({ getImagesForUnit }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [images, setImages] = useState([]);
  const [title, setTitle] = useState("");

  const open = async (unit) => {
    setTitle(`Unit ${unit?.code ?? unit?.name ?? unit?.id ?? ""}`);
    try {
      const urls = await getImagesForUnit(unit);
      const normalized = (urls || []).map((u) =>
        typeof u === "string" ? { src: u, alt: "" } : u
      );
      setImages(normalized);
    } catch (e) {
      console.error("getImagesForUnit failed:", e);
      setImages([]);
    }
    onOpen();
  };

  return { isOpen, onOpen: open, onClose, images, title };
};